import client from "../../graphql/client";
import { loader } from "graphql.macro";

const editOrganisationLabelMutation = loader("../../graphql/mutations/editCompanyLabel.graphql");

export default function editOrganisationLabelAction(id, name) {
    return () => {
        return client.mutate({
            mutation: editOrganisationLabelMutation,
            variables: { id, name }
        });
    };
}
